module.exports = __webpack_public_path__ + "static/img/code5.8ce4276.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/code5.png
// module id = SsRc
// module chunks = 35